import { render, staticRenderFns } from "./change_image_component.vue?vue&type=template&id=5b996be2&scoped=true"
import script from "./change_image_component.vue?vue&type=script&lang=js"
export * from "./change_image_component.vue?vue&type=script&lang=js"
import style0 from "./change_image_component.vue?vue&type=style&index=0&id=5b996be2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b996be2",
  null
  
)

export default component.exports